import { render, staticRenderFns } from "./formUpload.vue?vue&type=template&id=76a5ac5c&scoped=true"
import script from "./formUpload.vue?vue&type=script&lang=js"
export * from "./formUpload.vue?vue&type=script&lang=js"
import style0 from "./formUpload.vue?vue&type=style&index=0&id=76a5ac5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a5ac5c",
  null
  
)

export default component.exports